import { useState } from "react";
import Cookies from "universal-cookie";

export function useCookie<S>(
  key: string,
  defaultValue: S
): [S, (cookieValue: S) => void] {
  const cookies = new Cookies();
  const [cookie, setCookie] = useState(cookies.get(key) || defaultValue);
  const updateCookie = (cookieValue: any) => {
    setCookie(cookieValue);
    cookies.set(key, cookieValue);
  };
  return [cookie, updateCookie];
}
